import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api-service/api.service';
import { RESOURCES } from '@shared/constants/resources.constants';


@Injectable({
  providedIn: 'root',
})
export class RecoverPasswordService {
    private apiService: ApiService = inject(ApiService);

  sendLinkToResetPassword(email: string) {
    return this.apiService.post(RESOURCES.sendLinkToResetPassword, { email });
   }

}